import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as fallback for cross-site cookie issues
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("tf_token");
  if (t) config.headers["Authorization"] = `Bearer ${t}`;
  return config;
});

export default api;
export { API };
